import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './en';
import { th } from './th';

export const SUPPORTED_LANGS = ['en', 'th'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    resources: {
      en: { translation: en },
      th: { translation: th },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'opensoi.lang',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

const applyBodyClass = (lng: string) => {
  if (typeof document === 'undefined') return;
  document.body.classList.toggle('lang-th', lng === 'th');
  document.documentElement.lang = lng;
};
applyBodyClass(i18n.language);
i18n.on('languageChanged', applyBodyClass);

export default i18n;
